module.exports = function (app, mod) {
  return "\n  <div class=\"arcade-invite\">\n  </div>";
};